import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a1b0f10"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const htmlComputed = computed(() => {
  return localStorage.getItem("mobiePreview") ?? "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "content",
    innerHTML: _unref(htmlComputed)
  }, null, 8, _hoisted_1))
}
}

})